import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { debounce } from "lodash"
import * as customerApis from "../utilities/apis/customer"
import * as functions from "../utilities/enumerations/functions"

const NewMessageModal = (props) => {
  const { token, user, permissions } = useSelector(state => state.user)
  const [mobile, setMobile] = useState("")
  const [customers, setCustomers] = useState([])

  const handleChange = useCallback(debounce(async (e) => {
    try {
      const mobile = e.target.value
      if (mobile.length < 3) throw new Error("Enter more than 1 digit")

      const response = await customerApis.getCustomers(token, functions.paramsToQuery({ mobile }))
      if (!response.status) throw new Error(response.message)
      if (response.customers && response.customers.length === 0) throw new Error(response.message)

      setCustomers(response.customers)
    } catch (error) {
      setCustomers([])
    }
  }, 800), [])

  return (
    <div className="modal fade" id="newMessageModal" tabIndex="-1" aria-labelledby="newMessageModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-md modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5 fw-bold" id="newMessageModalLabel">New Message</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body p-0">
            <div className="p-2">
              <input type="text" className="form-control" placeholder="Type atleast 4 digits" onChange={handleChange} />
            </div>
            <div className="list-group list-group-flush">
              {customers.map((customer) => {
                return (
                  <button type="button" className="list-group-item list-group-item-action" onClick={() => props.handleSelect(customer)} data-bs-dismiss="modal">
                    {customer.name || "Customer"}<br />
                    {customer.mobile}
                  </button>
                )
              })}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Save</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewMessageModal
